import React, { Fragment, useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { attributeModifier } from '../../../utils/calculations';

import { saveCharacter } from '../../../actions/character';

const CompanionEditModal = ({
    selectedComp,
    character: {
        character
    },
    saveCharacter,
    closeModal
}) => {
    
    var [curCompData, updateCurCompData] = useState(selectedComp);

    const {
        astrobiologyLevel,
        espionageLevel,
        explosivesLevel,
        techLevel,
        inventory,
        companions
    } = character;

    const getCompanionInventory = () => {
        if(curCompData.inventory !== undefined){
            
            const invElements = curCompData.inventory.map((item, index) => (
                <div className="compInvContainer" key={index}>
                    <div className="itemName">{item.name}</div>
                    <div className="compInvOptions">
                        <div onClick={e => removeItem(item)(e)}>Use/Drop</div>
                        <div onClick={e => giveToCharacter(item)(e)}>Give to {character.name}</div>
                    </div>
                </div>
            ));
    
            return invElements;
        }
        
    }

    const getCompanionActions = () => {
        if(curCompData.actions !== undefined){
            
            const actElements = curCompData.actions.map((a, index) => (
                <div className="compInvContainer" key={index}>
                    <div className="itemName">{a}</div>
                </div>
            ));
    
            return actElements;
        }
        
    }

    const getCompanionCurCapacity = () => {

        var newCap = 0;

        if(selectedComp.inventory !== undefined){
            
            selectedComp.inventory.map((item) => {
                newCap += parseInt(item.weight.$numberDecimal)
            })

            
        }

        return newCap;
        
    }

    const onChange = e => {

        var newInput = e.target.value;

        if(
            e.target.name === 'currentHP'
        ){
            newInput > selectedComp.baseHP && (newInput = selectedComp.baseHP);
        }

        if(
            e.target.name === 'currentDIS'
        ){
            newInput > selectedComp.baseDIS && (newInput = selectedComp.baseDIS);
        }

        if(
            e.target.name === 'currentKIN'
        ){
            newInput > selectedComp.baseKIN && (newInput = selectedComp.baseKIN);
        }

        updateCurCompData({
            ...curCompData,
            [e.target.name]: newInput
        });
    }

    const saveCompanion = () => e => {
        const updatedComps = [...companions];
        const curInd = companions.findIndex(x => x.name === curCompData.name);

        updatedComps[curInd] = curCompData;

        saveCharacter({
            ...character,
            "companions": updatedComps
        });

        closeModal();
    }

    const removeItem = (item) => (e) => {

        var newCompInv = [...curCompData.inventory]

        newCompInv.splice(newCompInv.findIndex(x => x.name === item.name),1);

        var curComps = [...character.companions];

        // Save index of selected companion and current state of inventory as vars
        var compInd = curComps.findIndex(x => x.name === selectedComp.name);

        // Create a new companion object with updated inventory
        var newComp = {
            ...selectedComp,
            "inventory": [...newCompInv]
        }

        updateCurCompData(newComp);

        // Save the new companion data into the variable companion list
        curComps[compInd] = newComp;

        // Save character
        saveCharacter({
            ...character,
            "companions": curComps
        });

    }

    const giveToCharacter = (item) => (e) => {

        // Update the comp's inventory to not include the selected item
        var newCompInv = [...curCompData.inventory]

        newCompInv.splice(newCompInv.findIndex(x => x.name === item.name),1);
        //newCompInv = newCompInv.filter(i => i._id !== item._id);

        var curComps = [...character.companions];

        // Save index of selected companion and current state of inventory as vars
        var compInd = curComps.findIndex(x => x.name === selectedComp.name);

        // Create a new companion object with updated inventory
        var newComp = {
            ...selectedComp,
            "inventory": [...newCompInv]
        }

        updateCurCompData(newComp);

        // Save the new companion data into the variable companion list
        curComps[compInd] = newComp;

        var newCharInv = [...character.inventory, item]

        // Save character
        saveCharacter({
            ...character,
            "inventory": newCharInv,
            "companions": curComps
        });

        
    }

    return (
        <Fragment>
            <div className="companionContainer">
            <div className="compContCol">
                <h1>{selectedComp.name}</h1>
                <div className="compAttrContainer">
                    <h3 className="text-blue">Notes</h3>
                    <textarea className="info-container" name='notes' value={curCompData.notes} cols="20" rows="18" onChange={onChange}></textarea>
                </div>
                
                
            </div>
            <div className="compContCol">
                <div className="compAttrContainer">
                    <h3 className="text-blue">
                        Attribute Modifiers
                    </h3>
                    <div className="compAttrList">
                        <div>
                            <p>STR</p>
                            <div className="compAttrMod">{attributeModifier(selectedComp.STR)}</div>
                        </div>
                        <div>
                            <p>DEX</p>
                            <div className="compAttrMod">{attributeModifier(selectedComp.DEX)}</div>
                        </div>
                        <div>
                            <p>CON</p>
                            <div className="compAttrMod">{attributeModifier(selectedComp.CON)}</div>
                        </div>
                        <div>
                            <p>INT</p>
                            <div className="compAttrMod">{attributeModifier(selectedComp.INT)}</div>
                        </div>
                        <div>
                            <p>WIS</p>
                            <div className="compAttrMod">{attributeModifier(selectedComp.WIS)}</div>
                        </div>
                        <div>
                            <p>CHA</p>
                            <div className="compAttrMod">{attributeModifier(selectedComp.CHA)}</div>
                        </div>
                    </div>
                </div>
                <div className="compAttrContainer">
                    <h3 className="text-blue">
                        Other Stats
                    </h3>
                    <div className="compAttrList">
                        <div>
                            <p>Movement</p>
                            <div>{selectedComp.movement}</div>
                        </div>
                        <div>
                            <p>Passive Perception</p>
                            <div>{selectedComp.passivePerception}</div>
                        </div>
                    </div>
                </div>
                <div className="compAttrContainer">
                    <h3 className="text-blue">Actions</h3>
                    {getCompanionActions()}
                </div>
            </div>
            <div className="compContCol">
                <div className="compAttrContainer">
                    <h3 className="text-blue">Health & Defense</h3>
                    <div className="compAttrList">
                        <div className="compDefContainer">
                            <p>HP</p>
                            <input type="number" name='currentHP' value={curCompData.currentHP} onChange={onChange} />/ <span>{selectedComp.baseHP}</span>
                        </div>
                        <div className="compDefContainer">
                            <p>DIS</p>
                            <input type="number" name='currentDIS' value={curCompData.currentDIS} onChange={onChange} />/ <span>{selectedComp.baseDIS}</span>
                        </div>
                        <div className="compDefContainer">
                            <p>KIN</p>
                            <input type="number" name='currentKIN' value={curCompData.currentKIN} onChange={onChange} />/ <span>{selectedComp.baseKIN}</span>
                        </div>
                        <div>
                            <p>TARG</p>
                            <div>{selectedComp.TARG}</div>
                        </div>
                        <div>
                            <p>EVA</p>
                            <div>{selectedComp.EVA}</div>
                        </div>
                    </div>
                </div>
                <div className="compAttrContainer">
                    <h3 className="text-blue">Carrying Capacity</h3>
                    <div className="compAttrList">
                        <div className="compDefContainer">
                            {getCompanionCurCapacity()} / <span>{selectedComp.maxCapacity}</span>
                        </div>
                    </div>
                </div>
                <div className="compAttrContainer">
                    <h3 className="text-blue">Inventory</h3>
                    {getCompanionInventory()}
                </div>
            </div>
        </div>
        <div className="saveCompButContainer">
            <div className="saveCompBut" onClick={e => saveCompanion()(e)}>Save Companion Info</div>
        </div>
        </Fragment>
    );
};

CompanionEditModal.propTypes = {
    selectedComp: PropTypes.object.isRequired,
    character: PropTypes.object.isRequired,
    saveCharacter: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character
});

export default connect(mapStateToProps, {saveCharacter})(CompanionEditModal);